import React, { Component } from 'react';
import Items from './Items';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LineItem from './LineItem';
import Itempopup from './components/Itempopup';

const styles = (theme) => ({
  root: {
    width: '93%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  listMobileTitle: {
    textAlign: 'center',
    backgroundColor: '#f0f0f0',
    fontSize: 20,
    padding: 15,
    fontWeight: 'bold',
  },
  expand: {
    boxShadow: 'none',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#eee',
  },
  expandDetails: {
    padding: 0,
    backgroundColor: '#fbfbfb',
  },
  expandIcon: {
    color: '#000',
    right: 27,
    [theme.breakpoints.down('md')]: {
      right: 25,
    },
    [theme.breakpoints.down('sm')]: {
      right: 31,
    },
  },
  expandStyle: {
    fontSize: 40,
  },
  list: {
    width: '100%',
    padding: 0,
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '0 6px',
    },
  },
  title: {
    width: '100%',
    fontSize: 22,
    color: '#000',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 17,
    },
  },
});

class Category extends Component {
  state = {
    hasItems: true,
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  //  componentDidUpdate(){
  //    this.setState({hasItems:true})
  //  }
  noItems = (hasitems) => {
    this.setState({ hasitems: hasitems });
  };

  render() {
    let style = { 'font-weight': '550px', display: 'block' };
    const { classes } = this.props;
    let items = [];
    let item_count = 0;
    items = this.props.items.map((item, index) => {
      let match = this.props.query;

      let re = new RegExp(match, 'gi');
      if (item.name.match(re) || this.props.query === '') {
        item_count++;
        return (
          <LineItem
            url={item.image ? item.image : null}
            isNotAvailable={item.isNotAvailable ? true : false}
            description={item.description}
            name={item.name}
            price={item.price}
            click={() => this.props.click(item)}
            // cick open the pop up dialog
            // click={this.handleClickOpen}
            // cick open the pop up dialog
            key={index}
            promoCode={this.props.promoCode}
            color={this.props.color}
          />
        );
      }
    });
    // console.log(item_count)
    return (
      <div>
        {item_count ? (
          <section className='section' id={this.props.name}>
            {/* <span id="cat-title" title={this.props.name}>
              <h5 style={style}>{this.props.name}</h5>
            </span>
            <hr className="seperation-line" /> */}
            {/* <h5 id="cat-title" style={style}>{props.name}</h5> */}

            {/* <div id="placeholder-header">
        
        </div> */}
            <div className={classes.root}>
              {/* <Hidden mdUp> */}
              <div className='menu-mobile'>
                <Typography
                  variant='title'
                  component='h1'
                  className={classes.listMobileTitle}
                >
                  {this.props.name}
                </Typography>
                <List
                  style={{
                    padding: 0,
                  }}
                >
                  {items}
                </List>
              </div>
              {/* </Hidden> */}
              {/* <Hidden smUp> */}
              <div className='menu-desktop'>
                <ExpansionPanel defaultExpanded className={classes.expand}>
                  <ExpansionPanelSummary
                    classes={{
                      expand: classes.expand,
                      expandIcon: classes.expandIcon,
                    }}
                    className={classes.expand}
                    expandIcon={
                      <ExpandMoreIcon className={classes.expandStyle} />
                    }
                  >
                    <Typography className={classes.title}>
                      {this.props.name}
                    </Typography>
                    {/* <span id="cat-title" title={this.props.name}></span> */}
                    {/* <h5 style={style}>{this.props.name}</h5> */}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails className={classes.expandDetails}>
                    <List className={classes.list}>{items}</List>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
              {/* </Hidden> */}
            </div>
            {/* dialog pop up */}
            <Itempopup open={this.state.open} close={this.handleClose} />
            {/* dialog pop up */}
          </section>
        ) : null}
      </div>
    );
  }
}
export default withStyles(styles)(Category);



// WEBPACK FOOTER //
// ./src/Category.js